var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopyLinkHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#004BA5",
    stroke: "#004BA5",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89474 20L16.8421 20C17.4789 20 18 19.4682 18 18.8182L18 10.5455L16.8421 10.5455L16.8421 18.8182L9.89474 18.8182L9.89474 20ZM8.15789 17.6364L14.5263 17.6364C15.1632 17.6364 15.6842 17.1045 15.6842 16.4545L15.6842 8.18182C15.6842 7.53182 15.1632 7 14.5263 7L8.1579 7C7.52105 7 7 7.53182 7 8.18182L7 16.4545C7 17.1045 7.52105 17.6364 8.15789 17.6364ZM8.1579 8.18182L14.5263 8.18182L14.5263 16.4545L8.15789 16.4545L8.1579 8.18182Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyLinkHover);
export default __webpack_public_path__ + "static/media/iconCopyLinkHover.4aaef77543147624067af93a44b49f36.svg";
export { ForwardRef as ReactComponent };